import { createRouter, createWebHashHistory } from "vue-router"

const routes = [
  {
    path: "/",
    redirect: "/login",
  },
  {
    path: "/login",
    name: "Login",
    meta: {
      title: "登录",
    },
    component: () =>
      import(/* webpackChunkName: "login" */ "@/views/login/index.vue"),
  },
  {
    path: "/official",
    name: "Official",
    meta: {
      title: "公众号",
    },
    component: () =>
      import(/* webpackChunkName: "login" */ "@/views/official/index.vue"),
  },
  {
    path: "/studentCard",
    name: "studentCard",
    meta: {
      title: "公众号",
    },
    component: () =>
      import(/* webpackChunkName: "login" */ "@/views/official/studentCard.vue"),
  },
  {
    path: "/indexParent",
    name: "IndexParent",
    meta: {
      title: '访客管理'
    },
    component: () =>
      import(/* webpackChunkName: "login" */ "@/views/login/indexParent.vue"),
  },
  {
    path: "/visitorApply",
    name: "VisitorApply",
    meta: {
      title: '访客管理'
    },
    component: () =>
      import(
        /* webpackChunkName: "VisitorApply" */ "@/views/visitorApply/index.vue"
      ),
  },
  {
    path: "/searchVisitorList",
    name: "SearchVisitorList",
    meta: {
      title: '访客管理'
    },
    component: () =>
      import(
        /* webpackChunkName: "SearchVisitorList" */ "@/views/visitorApply/components/searchList.vue"
      ),
  },
  {
    path: "/visitorAgreeApply",
    name: "VisitorAgreeApply",
    meta: {
      title: '访客管理'
    },
    component: () =>
      import(
        /* webpackChunkName: "VisitorAgreeApply" */ "@/views/visitorApply/visitorAgreeApply.vue"
      ),
  },
  {
    path: "/visitorRefuseApply",
    name: "VisitorRefuseApply",
    meta: {
      title: '访客管理'
    },
    component: () =>
      import(
        /* webpackChunkName: "VisitorRefuseApply" */ "@/views/visitorApply/visitorRefuseApply.vue"
      ),
  },
  {
    path: "/visitorRecord",
    name: "VisitorRecord",
    meta: {
      title: '访客管理'
    },
    component: () =>
      import(
        /* webpackChunkName: "VisitorRecord" */ "@/views/visitorRecord/index.vue"
      ),
  },
  {
    path: "/visitorRecordDetail",
    name: "VisitorRecordDetail",
    meta: {
      title: '访客管理'
    },
    component: () =>
      import(
        /* webpackChunkName: "VisitorRecordDetail" */ "@/views/visitorRecord/visitorRecordDetail.vue"
      ),
  },
  {
    path: "/about",
    name: "About",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  {
    path: "/studentLeaveTeacher",
    name: "StudentLeave",
    meta: {
      title: '老师代请'
    },
    component: () =>
      import(/* webpackChunkName: "StudentLeave" */ "../views/studentLeave/index.vue"),
  },
  {
    path: "/studentSelect",
    name: "StudentSelect",
    meta: {
      title: '对象选择'
    },
    component: () =>
      import(/* webpackChunkName: "StudentSelect" */ "../views/studentLeave/studentSelect.vue"),
  },
  {
    path: "/leaveDetail",
    name: "LeaveDetail",
    meta: {
      title: '学生请假'
    },
    component: () =>
      import(/* webpackChunkName: "LeaveDetail" */ "../views/studentLeave/leaveDetail.vue"),
  },
  {
    path: "/studentLeaveParent",
    name: "ParentIndex",
    meta: {
      title: '学生请假'
    },
    component: () =>
      import(/* webpackChunkName: "ParentIndex" */ "../views/studentLeave/parentIndex.vue"),
  },
  {
    path: "/leaveAgree",
    name: "LeaveAgree",
    meta: {
      title: '学生请假'
    },
    component: () =>
      import(/* webpackChunkName: "LeaveAgree" */ "../views/studentLeave/studentLeaveAgreeApply.vue"),
  },
  {
    path: "/leaveRefuse",
    name: "LeaveRefuse",
    meta: {
      title: '学生请假'
    },
    component: () =>
      import(/* webpackChunkName: "LeaveAgree" */ "../views/studentLeave/studentLeaveRefuseApply.vue"),
  },
  {
    path: "/todoList",
    name: "TodoList",
    meta: {
      title: '我的待办'
    },
    component: () =>
      import(/* webpackChunkName: "TodoList" */ "../views/todoList/index.vue"),
  },
  {
    path: "/msgCenter",
    name: "MsgCenter",
    meta: {
      title: '消息中心'
    },
    component: () =>
      import(/* webpackChunkName: "MsgCenter" */ "../views/msgCenter/index.vue"),
  },

  {
    path: "/repair",
    name: "repair.index",
    component: () => import("../layout/blank.vue"),
    children: [
      {
        path: "report",
        name: "repair.report",
        component: () => import("../layout/blank.vue"),
        children: [
          {
            path: "apply", // 我的申请-列表页面
            name: "repair.report.apply",
            meta: {
              title: '我的申请'
            },
            component: () => import("../views/repair/report/apply.vue"),
          },
          {
            path: "applyDetail", // 我的申请-详情页面
            name: "repair.report.applyDetail",
            meta: {
              title: '详情'
            },
            component: () => import("../views/repair/report/applyDetail.vue"),
          },
          {
            path: "applySelect", // 我的申请-添加/编辑页面
            name: "repair.report.applySelect",
            meta: {
              title: '选择审批人'
            },
            component: () => import("../views/repair/report/applySelect.vue"),
          },
          {
            path: "applySave", // 我的申请-添加/编辑页面
            name: "repair.report.applySave",
            meta: {
              title: '申请报修'
            },
            component: () => import("../views/repair/report/applySave.vue"),
          },
          {
            path: "audit", // 我的审批-列表页面-待处理
            name: "repair.report.audit",
            meta: {
              title: '我的审批'
            },
            component: () => import("../views/repair/report/audit.vue"),
          },
          {
            path: "audited", // 我的审批-列表页面-已处理
            name: "repair.report.audited.vue",
            meta: {
              title: '我的审批'
            },
            component: () => import("../views/repair/report/audited.vue"),
          },
          {
            path: "auditcc", // 我的审批-列表页面-抄送我
            name: "repair.report.auditcc",
            meta: {
              title: '我的审批'
            },
            component: () => import("../views/repair/report/auditcc.vue"),
          },
          {
            path: "auditDetail", // 我的审批-详情页面
            name: "repair.report.auditDetail",
            meta: {
              title: '详情'
            },
            component: () => import("../views/repair/report/auditDetail.vue"),
          },
          {
            path: "auditRefuse", // 我的审批-拒绝页面
            name: "repair.report.auditRefuse",
            meta: {
              title: '拒绝审批'
            },
            component: () => import("../views/repair/report/auditRefuse.vue"),
          },
          {
            path: "auditAgree", // 我的审批-同意页面
            name: "repair.report.auditAgree",
            meta: {
              title: '同意审批'
            },
            component: () => import("../views/repair/report/auditAgree.vue"),
          },
          {
            path: "record",
            name: "repair.report.record",
            meta: {
              title: '报修管理'
            },
            component: () => import("../views/repair/report/record.vue"),
          },
          {
            path: "recordDetail",
            name: "repair.report.recordDetail",
            meta: {
              title: '详情'
            },
            component: () => import("../views/repair/report/recordDetail.vue"),
          },
          {
            path: "service",
            name: "repair.report.service",
            meta: {
              title: '我的维修'
            },
            component: () => import("../views/repair/report/service.vue"),
          },
          {
            path: "serviceDetail",
            name: "repair.report.serviceDetail",
            meta: {
              title: '详情'
            },
            component: () => import("../views/repair/report/serviceDetail.vue"),
          },
          {
            path: "serviceAllocate",
            name: "repair.report.serviceAllocate",
            meta: {
              title: '分配维修员'
            },
            component: () => import("../views/repair/report/serviceAllocate.vue"),
          },
        ],
      },
    ],
  },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
})

export default router
